module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_vm._v("Welcome to a year and a day of everyday witchcraft. Why a year and a day instead of 365 days like so many other books? In part because a year and a day is a traditional length of time used in contemporary witchcraft. Sometimes for study, as in those paths that follow a degree system, so that a person would study for a year and day to reach a certain level. Sometimes for a commitment or vow, like a handfasting ritual where the couple chooses to bind themselves for a year and a day, rather than a lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But there is another reason for the extra day in this book, one which you can choose to use or not, as you desire. I hope that by the time you have finished the rest of the book, you will be inspired to start your next year off in magical style, either with the ritual I’ve given you or one you write for yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The book is set up to follow an entire year, starting with the first of January, although you can really start with whichever date you happen to pick up the book and circle through from there. And, of course, there is nothing stopping you from simply opening a page at random, if that’s the way you roll. There are no rules here, and no one will look over your shoulder. My main intention is to give you simple ways to connect with your witchy self every day—in short, to enable you to witchify your life in small, easy, educational, and (I hope) fun daily bites. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you choose, however, you can use this book as your own personal “year and a day” journey. Beginners will find the entries helpful as an introduction to a personal magical practice, where more experienced witches and Pagans can use the entries as ways to renew or deepen their existing practice. My readers have been asking me to write a 365-day book and a devotional for some time; this book is a little bit of both—there are suggestions for how you can use that day’s snippet (if you want to), and there are also poems and words of witchy wisdom from the authors who inspire me, which I hope will touch you as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The book follows the Wheel of the Year and the general seasonal cycle, although depending on where you live, some aspects of it may apply less or more. Feel free to make adjustments to suit your own living situation and style.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The book also touches on various aspects of a modern Pagan practice, including connecting with nature and the Goddess and the God, holiday and lunar observations, easy crafts and recipes, questions to ponder, and, of course, the occasional simple spell, ritual, and affirmation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some of these things will appeal to different readers more than others, but it is my hope that you will find most of them helpful, meaningful, and useful. As witches living in the modern world, many of us find it hard to carve out the time to focus on our magical practices as much as we would like. This book is a way to make it easier to witchify your life one day at a time, getting more in touch with your own path, whatever form it might take.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Many blessings on your journey, and thanks for taking me along on the ride.")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_vm._v("Deborah Blake")]), _vm._v(" "), _c('div', {
    staticClass: "x15"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "i100",
    attrs: {
      "alt": "black cat",
      "src": "image/4.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#_idTextAnchor000"
    }
  }, [_vm._v("[contents]")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-719a5081","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YAAD.vue
// module id = 72
// module chunks = 0